import { AxiosError } from "axios"
import { ErrorType } from "@/shared/types"

const statusMessages: Record<number, string> = {
    400: "Проверьте правильность заполнения полей",
    401: "Сессия истекла, войдите заново",
    403: "Недостаточно прав",
    404: "Уровень не найден",
    409: "Уровень с таким номером уже существует",
    502: "Сервис уровней лояльности временно недоступен. Повторите попытку позже",
    503: "Сервис уровней лояльности временно недоступен. Повторите попытку позже",
    504: "Сервис уровней лояльности временно недоступен. Повторите попытку позже",
}

const servicePrefix = "loyalty-service: "

// Технические детали сателлита (`loyalty-service: connection refused`) владельцу сообщества
// ничего не говорят, поэтому на 5xx показываем свой текст, а не пробрасываем ответ наружу.
const isUnavailableStatus = (status?: number): boolean => {
    return status === 502 || status === 503 || status === 504
}

export const getApiErrorMessage = (error: unknown): string => {
    const knownError = error as AxiosError<ErrorType>
    const serverMessage = knownError.response?.data?.message

    if (serverMessage && !isUnavailableStatus(knownError.response?.status)) {
        return serverMessage.startsWith(servicePrefix)
            ? serverMessage.slice(servicePrefix.length)
            : serverMessage
    }

    const status = knownError.response?.status
    if (status && statusMessages[status]) {
        return statusMessages[status]
    }

    // Ответа нет вовсе (сеть/CORS/таймаут) — это тоже отказ связи, а не «данных нет».
    if (!knownError.response) {
        return "Не удалось связаться с сервером. Проверьте соединение и повторите попытку"
    }

    return "Произошла непредвиденная ошибка"
}
